/**
 * Formats a person's name for display.
 *
 * @param nameObj - should have the following (but not required):
 *                  nickName, firstName, lastName.
 * @param style - Order of format priority:
 *              1) Use nickName only if present
 *              2) Use firstName with lastName initial if both present
 *              3) Use firstName if present
 *              4) Use lastName if present
 */
export default function formatName(nameObj, style = 'default') {
  if (nameObj == null) {
    return nameObj
  }
  const nickName = nameObj.nickName
  const firstName = nameObj.firstName
  const lastName = nameObj.lastName
  if (nickName) {
    return nickName
  } else if (firstName && lastName) {
    return `${firstName} ${lastName.substring(0, 1)}`
  } else if (firstName) {
    return firstName
  } else if (lastName) {
    return lastName
  }
  return ''
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/filters/format-name.ts